export enum SalaryTableLevels {
  LEVEL1 = 'Erfahrungsstufe 1',
  LEVEL2 = 'Erfahrungsstufe 2',
  LEVEL3 = 'Erfahrungsstufe 3',
  LEVEL4 = 'Erfahrungsstufe 4',
  LEVEL5 = 'Erfahrungsstufe 5',
  LEVEL6 = 'Erfahrungsstufe 6',
}
export const allSalaryTableLevels = () => Object.values(SalaryTableLevels);
